import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Button, Icon } from '@node-space/ui-components'
import { PageHeader } from 'components/header/PageHeader'
import { useMappedRoles } from 'hooks/useMappedRoles'

export interface EarnDetailsHeaderProps {
  asset: string
  onWithdrawClick: () => void
  onDepositClick: () => void
}

export const EarnDetailsHeader = ({
  asset,
  onWithdrawClick,
  onDepositClick,
}: EarnDetailsHeaderProps) => {
  const { t } = useTranslation()
  const canEditEarn = useMappedRoles()?.earn?.canEdit

  return (
    <PageHeader
      description={
        <Box flex gap={8} align="center">
          <Avatar name={asset} type="currency" />
          <h2 className="text-h2 text-foreground-prominent">{asset}</h2>
        </Box>
      }
      renderRightSection={
        canEditEarn && (
          <Box flex gap={12}>
            <Button
              variant="secondary"
              onClick={onWithdrawClick}
              iconElement={<Icon name="CoinArrowOutCustom" />}
            >
              {t('earn.withdraw')}
            </Button>
            <Button onClick={onDepositClick} iconElement={<Icon name="Plus" />}>
              {t('earn.deposit')}
            </Button>
          </Box>
        )
      }
    />
  )
}
